//@ts-nocheck
import React from 'react'
//@ts-ignore
import LKPrintButton, { constants as LKPrintButtonConstants } from 'shared/LKPrintButton'
//@ts-ignore
import LKGridExportButton from 'shared/LKGrid/ExportButton'
//@ts-ignore
import withConstantPermissions from 'shared/containers/withConstantPermissions'
import translate from '../../translator'
import { constants as DCConstants } from '../../../DetailsContainer'

import container from './container'

import { CurrentGraphic, OldGraphic } from './Graphics'
import RestrGraphic from './RestrGraphic'
import { ScheduleProps } from '../../types.LoanDetails'

@withConstantPermissions()
class Schedule extends React.Component<ScheduleProps> {
  componentDidMount() {
    const { isInstanceCreated, data } = this.props

    // Avoid reinitialization on every mount
    if (!isInstanceCreated) {
      this.props.initialize(data)
    }
  }

  renderProperGraphic() {
    const { ID, data, oldGraphic, showCurrentGraphic } = this.props

    if (showCurrentGraphic) {
      return (
        <CurrentGraphic
          instanceName={`${DCConstants.DetailsGridPrefixes.loan}-${ID}-CurrentGraphic`}
          data={oldGraphic || data.schedule}
        />
      )
    }

    return (
      <OldGraphic
        instanceName={`${DCConstants.DetailsGridPrefixes.loan}-${ID}-OldGraphic`}
        ID={ID}
        restrGraphic={data.schedule_restr}
        data={oldGraphic}
      />
    )
  }

  render() {
    const { ID, hash, isInstanceCreated, data, showCurrentGraphic, permissions } = this.props

    const instanceName = showCurrentGraphic
      ? `${DCConstants.DetailsGridPrefixes.loan}-${ID}-CurrentGraphic`
      : `${DCConstants.DetailsGridPrefixes.loan}-${ID}-OldGraphic`

    if (!isInstanceCreated) {
      return null
    }

    return (
      <div className="u-flex u-fluid">
        <div className="u-flex u-directionColumn" style={{ flex: 3 }}>
          <div className="u-fluid u-relative">{this.renderProperGraphic()}</div>

          <div className="u-padding-5">
            {data.base.IsArrested !== 1 && permissions.PRINT_LOAN_SCHEDULE && (
              <LKPrintButton
                type={LKPrintButtonConstants.types.loan}
                upward
                name={translate('cmd_print')}
                ID={ID}
                hash={hash}
                page="printloanschedule"
              />
            )}

            <LKGridExportButton alias="export" instanceName={instanceName} />
          </div>
        </div>

        <div className="u-fluid u-flex">
          <RestrGraphic data={data.schedule_restr} base={data.base} ID={ID} hash={hash} />
        </div>
      </div>
    )
  }
}

export default container(Schedule)
